import React from 'react';
import { Loader } from '../../Loader/Loader';

export function TilesLoaderView() {
  return (
    <div className="c-product-tiles__column">
      <div className="c-product-tile c-product-tile--loading">
        <Loader size="medium" />
      </div>
    </div>
  );
}
